<!-- <app-top-nav-bar *ngIf="topNavbar.topNavbar()"></app-top-nav-bar> -->
<app-progress-bar></app-progress-bar>
<router-outlet />
<app-toaster></app-toaster>

